var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classNames from 'classnames';
import EllipsisOutlined from '@ant-design/icons/EllipsisOutlined';
import Button from '../button';
import { ConfigConsumer } from '../config-provider';
import Dropdown from './dropdown';
const ButtonGroup = Button.Group;
let DropdownButton = /** @class */ (() => {
    class DropdownButton extends React.Component {
        constructor() {
            super(...arguments);
            this.renderButton = ({ getPopupContainer: getContextPopupContainer, getPrefixCls, direction, }) => {
                const _a = this.props, { prefixCls: customizePrefixCls, type, disabled, onClick, htmlType, children, className, overlay, trigger, align, visible, onVisibleChange, placement, getPopupContainer, href, icon = <EllipsisOutlined />, title, buttonsRender } = _a, restProps = __rest(_a, ["prefixCls", "type", "disabled", "onClick", "htmlType", "children", "className", "overlay", "trigger", "align", "visible", "onVisibleChange", "placement", "getPopupContainer", "href", "icon", "title", "buttonsRender"]);
                const prefixCls = getPrefixCls('dropdown-button', customizePrefixCls);
                const dropdownProps = {
                    align,
                    overlay,
                    disabled,
                    trigger: disabled ? [] : trigger,
                    onVisibleChange,
                    getPopupContainer: getPopupContainer || getContextPopupContainer,
                };
                if ('visible' in this.props) {
                    dropdownProps.visible = visible;
                }
                if ('placement' in this.props) {
                    dropdownProps.placement = placement;
                }
                else {
                    dropdownProps.placement = direction === 'rtl' ? 'bottomLeft' : 'bottomRight';
                }
                const leftButton = (<Button type={type} disabled={disabled} onClick={onClick} htmlType={htmlType} href={href} title={title}>
        {children}
      </Button>);
                const rightButton = <Button type={type} icon={icon}/>;
                const [leftButtonToRender, rightButtonToRender] = buttonsRender([leftButton, rightButton]);
                return (<ButtonGroup {...restProps} className={classNames(prefixCls, className)}>
        {leftButtonToRender}
        <Dropdown {...dropdownProps}>{rightButtonToRender}</Dropdown>
      </ButtonGroup>);
            };
        }
        render() {
            return <ConfigConsumer>{this.renderButton}</ConfigConsumer>;
        }
    }
    DropdownButton.__ANT_BUTTON = true;
    DropdownButton.defaultProps = {
        type: 'default',
        buttonsRender: (buttons) => buttons,
    };
    return DropdownButton;
})();
export default DropdownButton;
